import $ from 'jquery';

import { buildGetHelpPath } from '@zapier/product-get-help';
import { TRIGGER_SCROLL_TRACKING } from '@zapier/toolbox-tracking';

import { dangerouslyDoNav } from 'app/common/utils/RouterUtils';
import { trackEvent } from 'app/track/trackingFunctions';

// Targets the legacy header/footer element which is still used in Django-land
export const legacyHeaderId = 'header';
export const legacyFooterId = 'footer';

export const bindLegacyEventHandlers = () => {
  // Note that jQuery is used to facilitate event delegation.
  // Otherwise we'd need to `addEventListener` and then look up
  // all of `e.target`'s parent nodes and use `matches` (which
  // has an inconsistent API across browsers anyway) to see if
  // a node was clicked, since `e.target` may be a child of the
  // node we care about. We could also select nodes and `addEventListener`
  // to each of them, but that's of course problematic if nodes
  // are added to the page later.
  const $body = $(document.body);

  $body.on(
    'click',
    '[href="mailto:contact@zapier.com"]:not([data-force="yes"])',
    e => {
      e.preventDefault();
      dangerouslyDoNav(buildGetHelpPath());
    }
  );

  // On the old Django homepage, we trigger scroll tracking via GTM
  window.addEventListener('DOMContentLoaded', () => {
    trackEvent(TRIGGER_SCROLL_TRACKING, {
      event: TRIGGER_SCROLL_TRACKING,
      eventLabel: TRIGGER_SCROLL_TRACKING,
    });
  });
};
